import { request_list, export_list, request_header } from '@/commons/hpod';
import { sendSuccessNotice, sendErrorNotice } from '@/commons/utils';
var FileSaver = require('file-saver');
import Vue from 'vue';
import configs from '@/configs';
const endpoint = 'accountantorder'

// initial state
const state = {
    loading: false,
    all: {
        data: [],
        total: 0,
        summary: {}
    }
};

// getters
const getters = {};

// actions
const actions = {
    getList({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list(endpoint, data => {
            commit('setList', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    export({ commit }, param) {
        commit("setLoading", { loading: true });
        export_list(endpoint, res => {
            commit("setLoading", { loading: false });
            var blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,"});
            FileSaver.saveAs(blob, "Order Export.xlsx");
        }, Vue.http, param, this.state.authentication.token);
    },
    markBought({ dispatch }, {orderIds, param}) {
        const header = {
            headers: request_header(this.state.authentication.token)
        };
        return Vue.http.post(`${configs.API}/admin/api/accountantorder/mark-bought/`, {
            OrderIDs: orderIds
        }, header).then(() => {
            sendSuccessNotice('Cập nhật đơn hàng sang Chờ phát hàng thành công.');
            return dispatch('getList', param);
        }).catch(error => {
            const reason = error.body && error.body.reason
                ? error.body.reason
                : 'Không thể cập nhật trạng thái đơn hàng.';
            sendErrorNotice(reason);
            return Promise.reject(error);
        });
    },
};

// mutations
const mutations = {
    setList(state, data) {
        state.all = data;
    },
    setLoading(state, { loading }) {
        state.loading = loading;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
